import { Camera } from 'domain/camera'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'

export interface DeleteCameraDialogProps {
  visible: boolean
  onHide: () => void
  deleteCamera: () => void
  camera: Camera
}

const DeleteCameraDialog: React.FC<DeleteCameraDialogProps> = ({
  visible,
  camera,
  onHide,
  deleteCamera,
}) => {
  const deleteCameraDialogFooter = (
    <div className='cameras-dialog-footer'>
      <Button
        label='Não'
        icon='pi pi-times'
        severity='success'
        className='cameras-btn-cancel'
        onClick={onHide}
      />
      <Button
        label='Sim'
        icon='pi pi-check'
        severity='danger'
        className='cameras-btn-confirm'
        onClick={deleteCamera}
      />
    </div>
  )
  return (
    <Dialog
      visible={visible}
      style={{ width: '450px' }}
      header='Confirmar Exclusão'
      modal
      className='cameras-confirm-dialog'
      footer={deleteCameraDialogFooter}
      onHide={onHide}
    >
      <div className='cameras-confirm-content'>
        <i className='pi pi-exclamation-triangle cameras-warning-icon' />
        <div className='cameras-confirm-text'>
          {camera && (
            <>
              <p>Tem certeza que deseja excluir a câmera</p>
              <strong className='cameras-highlight'>{camera.name}</strong>?
              <p className='cameras-warning-text'>
                Esta ação não pode ser desfeita.
              </p>
            </>
          )}
        </div>
      </div>
    </Dialog>
  )
}

export default DeleteCameraDialog
